import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'recorder',
    viewPath: props.viewPath,
  })

  return () => submit({ type: 'START' })
}
